// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".standalone-lamp-control .mode-control{display:block;margin-bottom:10px}\n", "",{"version":3,"sources":["webpack://./src/styles/standalone-lamp-control.scss"],"names":[],"mappings":"AAAA,uCAEI,aAAc,CACd,kBAAmB","sourcesContent":[".standalone-lamp-control {\n  .mode-control {\n    display: block;\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
